'use-strict';

/* @ngInject */
export default function MonitoringTaskTableController(
  $scope,
  $location,
  NgTableParams,
  monitoringApiService,
  interfaceService,
) {
  const self = this;
  $scope.allTasks = null;
  $scope.createdTasks = null;
  $scope.openTasks = null;

  /**
   * Change route to task form.
   * @param {number} taskId
   */
  $scope.taskClick = (taskId) => {
    $location.path(`/tasks/task/${taskId}`);
  };

  /**
   * Update the view's table with the provided data.
   * @param {Array<object>} data
   */
  const updateTableData = (table, data) => {
    table.settings({
      dataset: data,
    });
    interfaceService.applyScope($scope);
  };

  /**
   * Get all `Tasks` assigned to current user that are marked as `open`.
   */
  const getOpenTasks = () => {
    monitoringApiService.apiGetOpenTasks()
      .then((tasks) => {
        $scope.openTasks = tasks;
        updateTableData(self.openTaskTable, tasks);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const getCreatedTasks = () => {
    monitoringApiService.apiGetTasksCreatedByCurrentUser()
      .then((tasks) => {
        $scope.createdTasks = tasks;
        updateTableData(self.createdTasksTable, tasks);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const getAllTasks = () => {
    monitoringApiService.apiGetAllTasks()
      .then((tasks) => {
        $scope.allTasks = tasks;
        updateTableData(self.allTasksTable, tasks);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  $scope.changeRailItem = (item) => {
    if (item === 'Alle') getAllTasks();
    if (item === 'Erstellt') getCreatedTasks();
  };

  const init = () => {
    self.openTaskTable = new NgTableParams({
      sorting: {
        id: 'desc',
      },
    });

    self.createdTasksTable = new NgTableParams({
      sorting: {
        state: 'desc',
        id: 'desc',
      },
    });

    self.allTasksTable = new NgTableParams({
      sorting: {
        state: 'desc',
        id: 'desc',
      },
    });

    getOpenTasks();
  };

  init();
}
